import {  Component,  OnInit,  ViewChild} from '@angular/core';
import {  EquipmentService,  ManufacturerService,  ModelService,  PartsService,  MessageService} from 'src/app/services';
import {  FormControl} from '@angular/forms';
import {  Table} from 'primeng/table';
import {  Dialog} from 'primeng/dialog';
import {  ConfirmationService} from 'primeng/api';
import {  FacilityService} from 'src/app/services'
import {  UserDetail,  AccessUserInfo} from 'src/app/models';

@Component({
  selector: 'bart-parts-manager',
  templateUrl: './parts-manager.component.html',
  styleUrls: ['./parts-manager.component.scss'],
  providers: [ConfirmationService]
})
export class PartsManagerComponent implements OnInit {
  // Get from SSO
  userFacilityList: any;
  userInfo: UserDetail;
  USERNAME: string;
  USERID: number;
  BARTROLECODE: string;
  BARTROLEID: number;
  public ShowButtonSection: boolean = false;
  public ShowButtonSection1: boolean = false;
  public ShowPartDetails : boolean = false;
  public hideDivright: boolean = true;
  public displayDeleteBtn: boolean = true;
  public displaySaveBtn: boolean = true;
  public displayMergeBtn = true;
  public displaySelectBtn = true;
  public checkdylasis: any;
  equipmenttypes = [];
  manufacturers = [];
  models = [];
  vendors = [];
  modelsbyvendor = [];
  partsbyvendor = [];
  partsearchtypes = [{
      label: 'All',
      value: 'All'
    },
    {
      label: 'ADHOC',
      value: 'ADHOC'
    },
    {
      label: 'Non ADHOC',
      value: 'NonADHOC'
    },
    {
      label: 'Selected Models',
      value: 'SelectedModels'
    }
  ];
  partsbysearch = [];
  partsbysearchmerge = [];
 

  equipmenttypeid = new FormControl('');
  manufacturerid = new FormControl('');
  iprocvendorid = new FormControl('');

  mcols: any[];
  mcolsLoad: any[];
  pcols: any[];
  pcols2: any[];
  selectVendor: any;

  @ViewChild('dtm', {
    static: false
  }) tableRefdtm: Table;
  @ViewChild('dtmv', {
    static: false
  }) tableRefdtmv: Table;
  @ViewChild('dtpv', {
    static: false
  }) tableRefdtpv: Table;
  @ViewChild('dmrc', {
    static: false
  }) dialogRefdmrc: Dialog;
  @ViewChild('dtps', {
    static: false
  }) tableRefdtps: Table;
  @ViewChild('dtpm', {
    static: false
  }) tableRefdtpm: Table;


 


  selectedPartByVendor: any;
  selectedModels = [];
  selectedPartBySearch: any;
  selectedParts = [];
  selectedPartByMerge: any;

  dispModelRemoveConfirm: boolean = false; // show Model Remove confirm popup
  dispPartsSavedSuccess: boolean = false; // show Parts Saved success popup
  getModelsLoading: boolean = false;
  selectedPartLoading: boolean = false;
  dispPartsAssignedSuccess: boolean = false; // show Parts Assigned success popup
  dispPartsMergedSuccess: boolean = false; // show Parts Merged success popup
  dispPartsDeleteSuccess: boolean = false; // show Parts delete success popup
  
  partsearchterm: string = '';
  partsearchtype: string = '';
  mergesearchterm: string = '';
  mergereason: string = '';
  selectedCar: string = '';


  tvindex: number = 0;

  constructor(private equipmentService: EquipmentService,
    private manufacturerService: ManufacturerService, private modelService: ModelService,
    private partsService: PartsService, private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private facilityService: FacilityService) {}





  ngOnInit(): void {

    this.userFacilityList = this.facilityService.getCurrentUserFacilityMasterIdList();
    this.userInfo = AccessUserInfo.getUserInfo();
    this.USERNAME = this.userInfo.userName;
    this.USERID = this.userInfo.userId;
    this.BARTROLECODE = this.userInfo.bartRoleCode;
    this.BARTROLEID = this.userInfo.bartRoleId;

    this.getEquipmentTypes();
    this.getManufacturers();
    this.getVendors();
    this.getModels();

    this.mcols = [

      {
        field: 'modelManufacturer',
        header: 'Manufacturer',
        hidden: false
      },
      {
        field: 'modelnumber',
        header: 'Models',
        hidden: true
      }
    ];
    this.mcolsLoad = [


      {
        field: 'modelnumber',
        header: 'Models',
        hidden: true
      }
    ];

    this.pcols = [{
        field: 'partnumber',
        header: 'Part Number'
      },
      {
        field: 'partdescription',
        header: 'Part Description'
      },
      {
        field: 'iprocid',
        header: 'iProc ID'
      },
      {
        field: 'unitprice',
        header: 'Unit Price'
      },
      {
        field: 'mfgpartnumber',
        header: 'MFG Part Number'
      }
    ];

    this.pcols2 = [{
        field: 'partnumber',
        header: 'Part Number'
      },
      {
        field: 'partdescription',
        header: 'Part Description'
      },
      {
        field: 'iprocid',
        header: 'iProc ID'
      },
      {
        field: 'fullname',
        header: 'Created By'
      }
    ];
  }
  getEquipmentTypes() {

    this.equipmentService.getEquipmentTypes().toPromise().then((data) => {

      for (let i = 0; i < data['equipmentType'].length; i++) {
        this.equipmenttypes.push({
          label: data['equipmentType'][i].EquipmentTypeDescription,
          value: data['equipmentType'][i].EquipmentTypeId,
          equipmenttypedescription: data['equipmentType'][i].EquipmentTypeDescription,
          equipmenttypeid: data['equipmentType'][i].EquipmentTypeId
        })
      }
    }).catch(error => {
      this.handleError(error)
    });
  }

  getManufacturers() {
    var params = {
      "GETMANUFACTURERS": {
        "MANUFACTURERID": "0",
        "ISACTIVEFLAG": "",
        "WITHMODELS": "1",
        "SEARCHTERM": "",
        "WITHPARTS": "0"
      }
    };

    this.manufacturerService.getManufacturers(JSON.stringify(params)).toPromise().then((data) => {

      for (let i = 0; i < data['manufacturers'].length; i++) {
        this.manufacturers.push({
          label: data['manufacturers'][i].ManufacturerName,
          value: data['manufacturers'][i].ManufacturerID
        })
      }
    }).catch(error => {
      this.handleError(error)
    });
  }

  getVendors() {
    var params = {
      "GETVENDORS": {
        "ISACTIVEFLAG": "",
        "SEARCHTERM": ""
      }
    };


    this.manufacturerService.getVendors(JSON.stringify(params)).toPromise().then((data) => {

      for (let i = 0; i < data['manufacturers'].length; i++) {
        this.vendors.push({
          label: data['manufacturers'][i].ManufacturerName,
          value: data['manufacturers'][i].IProcVendorId
        })
      }
    }).catch(error => {
      this.handleError(error)
    });
  }

  getModels() {
    this.getModelsLoading = true;
    this.models = [];
    var params = {
      "GETMODELS": {
        "MANUFACTURERID": (this.manufacturerid.value != '' ? this.manufacturerid.value : 0),
        "EQUIPMENTTYPEID": (this.equipmenttypeid.value != '' ? this.equipmenttypeid.value : 0),
        "MODELID": "0",
        "SEARCHTERM": "",
        "MODELSONLY": "1"
      }
    };

    this.modelService.getModels(JSON.stringify(params)).toPromise().then((data) => {


      for (let i = 0; i < data['models'].length; i++) {
        this.models.push({
          modelid: data['models'][i].modelid,
          modelnumber: data['models'][i].modelnumber
        })
      }
      this.tableRefdtm.reset();
      this.getModelsLoading = false;
    }).catch(error => {
      this.handleError(error)
    });
  }

  getVendorInfo(showparts) {

    if (showparts == 1) {
      this.partsbyvendor = [];
    } else {
      this.modelsbyvendor = [];


    }

    var params = {
      "GETVENDORINFO": {
        "IPROCVENDORID": this.iprocvendorid.value,
        "SHOWPARTS": (showparts == 1 ? 1 : ''),
        "SHOWMODELS": (showparts == 1 ? '' : 1)
      }
    };

    this.manufacturerService.getVendorInfo(JSON.stringify(params)).toPromise().then((data: any) => {

      this.partsbyvendor = [];
      if (data['records'].length > 0) {
        this.ShowButtonSection = true;
        this.ShowButtonSection1 = true;

        for (let i = 0; i < data['records'].length; i++) {

          if (showparts == 1) {
            this.partsbyvendor.push({
              partnumber: data['records'][i].partNumber,
              partdescription: data['records'][i].partDescription,
              iprocid: data['records'][i].iProcId,
              unitprice: '$' + data['records'][i].unitPrice,
              mfgpartnumber: data['records'][i].mfgPartNumber,
              partid: data['records'][i].partId
            });
          } else {
            this.modelsbyvendor.push({
              modelid: data['records'][i].modelId,
              modelnumber: data['records'][i].ModelNumber,
              modelManufacturer: data['records'][i].modelManufacturer

            });
          }
        }
      } else {
        this.ShowButtonSection = false;
        this.ShowButtonSection1 = true;
      }
      this.tableRefdtpv.reset();
      this.tableRefdtmv.reset();
    })

  }
  getVendorInfoForCancel(showparts) {
    this.selectedPartLoading = true;
    this.selectVendor = 0;

    if (showparts == 1) {
      this.partsbyvendor = [];
    } else {
      this.modelsbyvendor = [];


    }

    var params = {
      "GETVENDORINFO": {
        "IPROCVENDORID": 0,
        "SHOWPARTS": (showparts == 1 ? 1 : ''),
        "SHOWMODELS": (showparts == 1 ? '' : 1)
      }
    };

    this.manufacturerService.getVendorInfo(JSON.stringify(params)).toPromise().then((data: any) => {


      this.ShowButtonSection = true;
      this.ShowButtonSection1 = true;
      this.modelsbyvendor = [];
      for (let i = 0; i < data['records'].length; i++) {


        this.modelsbyvendor.push({
          modelid: data['records'][i].modelId,
          modelnumber: data['records'][i].ModelNumber,
          modelManufacturer: data['records'][i].modelManufacturer

        });

      }
      this.selectedPartLoading = false;

    })

  }

  removeModelFromVendorConfirm(obj) {
    let manufacturerLabel = "";
    var tempmessage = '';
    if (this.iprocvendorid.value == 0) {
      manufacturerLabel = " - Vendor -"
      obj.iprocvendorid = 0;
    } else {
      manufacturerLabel = this.vendors.find(v => v.value == this.iprocvendorid.value).label
    }


    //tempmessage += this.vendors.find(v => v.value == this.iprocvendorid.value).label + '?';
    tempmessage = 'Are you sure you want to remove ' + obj.modelnumber + ': from ';
    tempmessage += manufacturerLabel + '?';

    this.confirmationService.confirm({
      message: tempmessage,
      accept: () => {
        //Actual logic to perform a confirmation          
        this.removeModelFromVendor(obj);
        this.dispModelRemoveConfirm = true;
      }
    });
  }

  removeModelFromVendor(obj) {
    var params = {
      "REMOVEMODELFROMVENDOR": {
        "VENDORID": this.iprocvendorid.value,
        "MODELID": obj.modelid
      }
    };

    this.partsService.removeModelFromVendor(JSON.stringify(params)).toPromise().then((data) => {

      this.getVendorInfo(0);
    }).catch(error => {
      this.handleError(error)
    });


  }

  assignModelsToVendor() {

    var modelidstr = '';
    for (var i = 0; i < this.selectedModels.length; i++) {
      var val = this.selectedModels[i]['modelid'];
      if (modelidstr == '') {
        modelidstr += val;
      } else {
        modelidstr += "," + val;
      }
    }


    if (this.iprocvendorid.value != '' && modelidstr != '') {
      this.confirmationService.confirm({
        message: 'Are you sure that you want to assign this model to the vendor?',
        accept: () => {
          var vendorname = this.vendors.find(v => v.value == this.iprocvendorid.value).label
          var params = {
            "ASSIGNMODELSTOVENDOR": {
              "VENDORID": this.iprocvendorid.value,
              "USERID": this.USERID,
              "MODELLISTIDS": modelidstr
            }
          };

          this.partsService.assignModelsToVendor(JSON.stringify(params)).toPromise().then((data) => {

            this.confirmationService.confirm({
              header: 'Parts saved',
              message: vendorname + ' parts added to the selected model(s).',
              icon: 'pi pi-check',
              acceptVisible: false,
              rejectVisible: false
            });
            this.getVendorInfo(0);
          }).catch(error => {
            this.handleError(error)
          });
        }
      });
     // this.selectedModels = [];
    } else {

      this.messageService.showAlertMessage("Model Error:Please select at least one model.");
    }

  }

  searchPartsFromPartsTab() {

    var checkdylasis = this.partsearchterm.toUpperCase()
    if (this.partsearchterm != undefined && this.partsearchterm.length < 3) {

      this.messageService.showAlertMessage("No Results:Search term must be at least three characters.");
      
       this.partsbysearch= [];
      return false;


    }
     else if (this.partsearchterm.toUpperCase() == 'DIALYSIS') {

      this.messageService.showAlertMessage("The word dialysis by itself is not a valid search term.");
      return false;
    } 
    else if((this.partsearchtype == 'SelectedModels') && (this.selectedModels.length == 0))
    {
      this.partsbysearch= [];
      this.messageService.showAlertMessage("Model Error:Please select at least one model.");
      return false;
    }
    else {
      var modelidstr = '';
      var isadhocflag = '';
      this.partsbysearch = [];
      for (var i = 0; i < this.selectedModels.length; i++) {
        var val = this.selectedModels[i]['modelid'];
        if (modelidstr == '') {
          modelidstr += val;
        } else {
          modelidstr += "," + val;
        }
      }

      if (this.partsearchtype == 'ADHOC') {
        isadhocflag = '1';
      } else if (this.partsearchtype == 'NonADHOC') {
        isadhocflag = '0';
      }

      var params = {
        "SEARCHPARTS": {
          "ALLPARTS": "0",
          "ISGRID": 1,
          "MANUFACTURERID": "-1",
          "ISMODELPARTSEARCH": (this.partsearchtype == 'SelectedModels' ? 1 : 0),
          "IPROCVENDORID": "0",
          "SEARCHTERM": this.partsearchterm,
          "ISADHOCFLAG": isadhocflag,
          "MODELIDLIST": (this.partsearchtype == 'SelectedModels' ? modelidstr : 0),
          "ORDERBY": "pp.partnumber asc"
        }
      };

      this.searchParts(params, this.partsbysearch);
    }
    this.resetSelectedParts();

  }

  searchPartsFromMergeTab() {

    if (this.mergesearchterm != undefined && this.mergesearchterm.length < 3) {

      this.messageService.showAlertMessage("No Results:Search term must be at least three characters.");
      
      return false;


    } else if (this.mergesearchterm.toUpperCase() == 'DIALYSIS') {

      this.messageService.showAlertMessage("Error:The word dialysis by itself is not a valid search term.");
      return false;
    } else {

      this.partsbysearchmerge = [];
      var params = {
        "SEARCHPARTS": {
          "ALLPARTS": 1,
          "ISGRID": 1,
          "MANUFACTURERID": "-1",
          "ISMODELPARTSEARCH": 0,
          "IPROCVENDORID": "0",
          "SEARCHTERM": this.mergesearchterm,
          "ISADHOCFLAG": '',
          "MODELIDLIST": 0,
          "ORDERBY": "pp.partnumber asc"
        }
      };

      this.searchParts(params, this.partsbysearchmerge);
    }
  }
  searchParts(params, objarray) {
    this.partsService.searchParts(JSON.stringify(params)).toPromise().then((data) => {

      for (let i = 0; i < data['parts'].length; i++) {
        objarray.push({
          partnumber: data['parts'][i].partNumber,
          partdescription: data['parts'][i].partDescription,
          iprocid: data['parts'][i].iprocId,
          fullname: data['parts'][i].fullName,
          partid: data['parts'][i].partId,
          vendorid: data['parts'][i].vendorId,
          manufacturername: data['parts'][i].manufacturerName,
          unitprice: data['parts'][i].unitPrice,
          isactiveflag: data['parts'][i].isActiveFlag,
          isadhocflag: data['parts'][i].isAdhocFlag
        });
      }
      this.tableRefdtps.reset();
      this.tableRefdtpm.reset();
    }).catch(error => {
      this.handleError(error)
    });
  }

  addToSelectedParts() {
    this.hideDivright = false;
    if (!(this.selectedParts.find(p => p.partid == this.selectedPartBySearch.partid))) {
      this.selectedParts.push(this.selectedPartBySearch);
    }
  }

  assignModelsToParts() {
    var modelidstr = '';
    var partidstr = '';
    for (var i = 0; i < this.selectedModels.length; i++) {
      var val = this.selectedModels[i]['modelid'];
      if (modelidstr == '') {
        modelidstr += val;
      } else {
        modelidstr += "," + val;
      }
    }
    for (var i = 0; i < this.selectedParts.length; i++) {
      var val = this.selectedParts[i]['partid'];
      if (partidstr == '') {
        partidstr += val;
      } else {
        partidstr += "," + val;
      }
    }

    if (modelidstr != '' && partidstr != '') {
      this.confirmationService.confirm({
        message: 'Are you sure that you want to assign this model to the part?',
        accept: () => {
          var params = {
            "ASSIGNMODELSTOPARTS": {
              "PartIDLIST": partidstr,
              "ModelIDList": modelidstr,
              "UserID": this.USERID 
            }
          };

          this.partsService.assignModelsToParts(JSON.stringify(params)).toPromise().then((data) => {

           // this.selectedPartBySearch = null;
          // this.selectedParts = [];
          //  this.selectedModels = [];
            this.dispPartsAssignedSuccess = true;
          }).catch(error => {
            this.handleError(error)
          });
        }
      });
    } else {

      this.messageService.showAlertMessage("Please select a model(s) and part");
    }
  }


  DeleteAssignedModelsParts() {
    var modelidstr = '';
    var partidstr = '';
    for (var i = 0; i < this.selectedModels.length; i++) {
      var val = this.selectedModels[i]['modelid'];
      if (modelidstr == '') {
        modelidstr += val;
      } else {
        modelidstr += "," + val;
      }
    }
    for (var i = 0; i < this.selectedParts.length; i++) {
      var val = this.selectedParts[i]['partid'];
      if (partidstr == '') {
        partidstr += val;
      } else {
        partidstr += "," + val;
      }
    }

    if (modelidstr != '' && partidstr != '') {
      this.confirmationService.confirm({
        message: 'Are you sure you want to remove the selected part(s) from the selected model(s)',
        accept: () => {
          var params = {
            "DELETEMODELPARTS": {
              "PartIDLIST": partidstr,
              "ModelIDList": modelidstr             
            }
          };

          this.partsService.deleteModelParts(JSON.stringify(params)).toPromise().then((data) => {
            this.resetSelectedParts();
            this.searchPartsFromPartsTab();
            this.dispPartsDeleteSuccess = true;

          }).catch(error => {
            this.handleError(error)
          });
        }
      });
    } else {

      this.messageService.showAlertMessage("Please select a model(s) and part");
    }
  }

  onRowSelect(event: any, template ? : any) {  
    this.ShowPartDetails = true;
 
    if(this.partsearchtype=='SelectedModels')
    {
     
      this.addToSelectedParts();
      this.displaySaveBtn = false;
      this.displayDeleteBtn = true;
      this.displayMergeBtn = false;
      this.displaySelectBtn = false;
    }
    else
    {
      this.displaySaveBtn = true;
      this.displayDeleteBtn = false;
      this.displayMergeBtn = true;
      this.displaySelectBtn = true;
        
        if(this.selectedParts.length == 0)
        {
        this.hideDivright = true;
        }

    }

  }

  mergePart() {
    var partidstr = '';
    if (this.selectedPartByMerge != null) {
      for (var i = 0; i < this.selectedPartByMerge.length; i++) {
        var val = this.selectedPartByMerge[i]['partid'];
        if (partidstr == '') {
          partidstr += val;
        } else {
          partidstr += "," + val;
        }
      }
    }

    if (partidstr != '' && this.mergereason != '' && this.mergereason.length>3) {
      this.confirmationService.confirm({
        message: 'Are you sure that you want to merge this part?',
        accept: () => {
          var params = {
            "MERGEPART": {
              "MERGEINTOPARTID": this.selectedPartBySearch.partid,
              "MERGEFROMPARTID": partidstr,
              "MERGEREASON": this.mergereason,
              "USERID": this.USERID
            }
          };

          this.partsService.mergePart(JSON.stringify(params)).toPromise().then((data) => {

            this.tvindex = 1; // Parts Tab
            this.dispPartsMergedSuccess = true;
           // this.selectedPartBySearch = null;
           // this.selectedPartByMerge = [];
           // this.partsbysearchmerge = [];
            this.mergereason = '';
            this.mergesearchterm = '';
          }).catch(error => {
            this.handleError(error)
          });
        }
      });
    } else 
    {
        let strMessage="";
        if(partidstr=="" || partidstr==null)
        {
          strMessage="Please select parts to merge. \n";
        }
        if(this.mergereason==null ||this.mergereason.length<4)
        {
          strMessage+="Merge Reason must be greater than 3 characters.";
        }
      this.messageService.showAlertMessage("Merge Error:"+strMessage);
    }

  }

  resetSelectedParts() {
    this.selectedPartBySearch = null;
    this.selectedParts = [];
    this.ShowPartDetails = false;
  }

  showMergeTab() {
    this.tvindex = 2; // Merge Tab
  }

  async resetVendor() {
    this.ShowButtonSection = false;
    this.iprocvendorid = new FormControl('');
    this.modelsbyvendor = [];
    this.partsbyvendor = [];
    this.tableRefdtpv.reset();
    this.tableRefdtmv.reset();
  }
  removeModelFromPartConfirm(i: number) {


    this.selectedParts.splice(i, 1);



  }
  removeModelFromMergeConfirm(i: number) {


    this.selectedPartByMerge.splice(i, 1);
  }

  handleError(errmessage) {
    // Log these errors?
    // this.messageService.add({key: 'toastKey', severity:'error', summary:'Error', detail:errmessage.error});
    //this.messageService.showAlertMessage(errormess);
  }

  closeAssignedSuccessClick()
  {
    this.dispPartsAssignedSuccess=false;
  }
  closeClickPartsMergedSuccess()
  {
    this.dispPartsMergedSuccess=false;
  }
  
  closeDeleteSuccessClick()
  {
    this.dispPartsDeleteSuccess=false;
  }
}
